import React from "react";
import "./Ourteam.css";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import abisha from "../../Media/abisha.jpg";
import antony from "../../Media/antony.JPG";
import hebeya from "../../Media/hebeya.jpeg";
import arsath from "../../Media/arsath.jpg";
import asiba from "../../Media/asiba.jpg";
import barwin from "../../Media/barwin.jpg";
import brinci from "../../Media/brinci.jpg";
import dhinesh from "../../Media/dhinesh.jpg";
import irine from "../../Media/Irine.jpg";
import jayasree from "../../Media/jayasree.jpg";
import jenish from "../../Media/jenish.jpg";
import kumareson from "../../Media/kumareson.jpg";
import Sreejith from "../../Media/Sree.jpg";
import kishore from "../../Media/kishore.jpg";
import preethi from "../../Media/Preethi.jpg"; 
import renjith from "../../Media/renjith.jpg";
import selva from "../../Media/selva.jpg";
import shaji from "../../Media/shaji.jpg";
import tony from "../../Media/tony.jpg";
import tharaniya from "../../Media/tharaniya.jpg";
import yuvarani from "../../Media/yuvarani.jpg";
import jeeva from '../../Media/jeeva.jpeg';
import anton from '../../Media/anton.jpeg';
import pushpa from '../../Media/raj.png';
import beula from '../../Media/beula.jpeg';
import maybe from "../../Media/Team2.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const teamData = [
  { name: "Abisha M", role: "Frontend Developer", image: abisha },
  { name: "Anton Aloy S", role: "FullStack Trainee", image: anton },
  { name: "Antony Godson J", role: "Frontend Developer", image: antony },
  { name: "Arsath Mohammed F", role: "Data Analyst", image: arsath },
  { name: "Asiba A", role: "Marketing Analyst", image: asiba },
  { name: "Barwin Raj E", role: "Backend Developer", image: barwin },
  { name: "Beula Raj R", role: "FullStack Developer", image: beula},
  { name: "Brinci N V", role: "Frontend Developer", image: brinci }, 
];

const teamDatatwo = [
  { name: "Dhinesh N", role: "Business Development Executive", image: dhinesh },
  { name: "Hebeya Salon S K", role: "Data Scientist", image: hebeya },
  { name: "Irine Saranya S", role: "Frontend Developer", image: irine },
  { name: "Jayasree Ramalekshmi E", role: "Frontend Developer", image: jayasree},
  { name: "Jeeva V", role: "FullStack Trainee", image: jeeva },
  { name: "Jenish J", role: "Software Developer", image: jenish },
  { name: "Kishore Kumar S", role: "Backend Developer", image: kishore },
  { name: "Kumareson RS", role: "Sr. Backend Developer", image: kumareson },
  { name: "Preethi J P", role: "Frontend Developer", image: preethi },
  { name: "Pushpa Raj Y", role: "Devops cum Network Engineer", image: pushpa },
  { name: "Renjith R", role: "Network Engineer", image: renjith },
  { name: "Selva Nayagam M", role: "Backend Developer", image: selva },
  { name: "Shaji P", role: "Technical Lead", image: shaji },
  { name: "Sreejith T S", role: "UI/UX Designer", image: Sreejith },
  { name: "Sukesh Tony G", role: "Backend Developer", image: tony },
  { name: "Swarna Tharaniya P K", role: "HR Executive cum Admin", image: tharaniya},
  { name: "Yuvarani R", role: "Business Analyst", image: yuvarani },
  { name: "Maybe You?", role: "Future Innovator", image: maybe },
];

const ResponsiveCarousel = ({ data }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 3000, 
    pauseOnHover: true,
  };

  const handleRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <div className="carousel-wrapper">
      <Slider {...settings}>
        {data.map((member, index) => (
          <div
            className="team-card"
            key={index}
            data-aos="fade-up"
            onContextMenu={handleRightClick}
          >
            <img src={member.image} alt={member.name} className="team-image" />
            <div className="team-info">
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

const Ourteam = () => {
  const [showMore, setShowMore] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <div className="ourteam-section">
      <div className="ourteam-section-heading">
        <p className="ourteam-section-heading-text">What We Believe</p>
      </div>
      <div className="ourteam-section-content">
        <p className="ourteam-section-content-text">
          The company is more important than the journey or destination. So we
          make sure our clients know that the entire Althi Solutions team is
          behind them. 24/7 never stopped us from responding to challenges for
          our clients. Stop by anytime to see our team in action!
        </p>
      </div>

      {isMobile ? (
        <ResponsiveCarousel data={teamData} />
      ) : (
        <div className="team-grid">
          {teamData.map((member, index) => (
            <div
              className="team-card"
              key={index}
              data-aos="fade-up"
              onContextMenu={handleRightClick}
            >
              <img
                src={member.image}
                alt={member.name}
                className="team-image"
              />
              <div className="team-info">
                <h3>{member.name}</h3>
                <p>{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {showMore &&
        (isMobile ? (
          <ResponsiveCarousel data={teamDatatwo} />
        ) : (
          <div className="team-grid">
            {teamDatatwo.map((member, index) => (
              <div
                className="team-card"
                key={index}
                data-aos="fade-up"
                onContextMenu={handleRightClick}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-image"
                />
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        ))}

      <div className="ourteam-section-button">
        <button className="Primary-two" onClick={() => setShowMore(!showMore)}>
          <span className="testing">
            {showMore ? "Show Less" : "Show More"}
          </span>
          {showMore ? <GoChevronUp /> : <GoChevronDown />}
        </button>
      </div>
    </div>
  );
};

export default Ourteam;
